import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icon, IconCheck, TextCallout1 } from 'blocket-ui'
import { mediaQueries, ie11media } from '@blazar-plugins/device'

const COLOR_ICON_SIZE = 20

const ItemsWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media ${mediaQueries.large} {
    display: grid;
    grid-template-columns: repeat(5, ${COLOR_ICON_SIZE}px);
  }

  ${ie11media} {
    width: 163px;
  }
`

export const ItemWrapper = styled.a`
  position: relative;
  display: block;
  cursor: pointer;

  ${ie11media} {
    float: left;
  }
`

const ellipse = Icon.svguri`
  <svg width="47" height="47" xmlns="http://www.w3.org/2000/svg">
    <path d="M40.534 6.765C36.47 2.62 30.136 1.043 23.799 1c-6.336.043-12.671 1.62-16.735 5.765C2.918 10.83 1.342 17.164 1.3 23.5c.044 6.336 1.62 12.671 5.765 16.735C11.128 44.38 17.463 45.957 23.8 46c6.337-.043 12.671-1.62 16.735-5.765 4.146-4.064 5.722-10.4 5.765-16.735-.043-6.336-1.62-12.671-5.765-16.735" stroke="${({
      stroke,
    }) => stroke}" fill="${({ fill }) => fill}" fill-rule="evenodd"/>
  </svg>
`

const _createColorIcon = (fill, stroke) => {
  return <Icon icon={ellipse({ fill, stroke })} width={COLOR_ICON_SIZE} height={COLOR_ICON_SIZE} />
}

const QUERY_KEY_TO_COLOR_DATA_MAP = {
  cxcw: { icon: _createColorIcon('#FFFFFF', '#CCC'), checkColor: '#000' },
  // gray
  cxcs: { icon: _createColorIcon('#999999'), checkColor: '#FFF' },
  // brown
  cxcn: { icon: _createColorIcon('#AD9167'), checkColor: '#FFF' },
  // black
  cxcb: { icon: _createColorIcon('#363433'), checkColor: '#FFF' },
  // red
  cxcr: { icon: _createColorIcon('#EF404F'), checkColor: '#FFF' },
  // yellow
  cxcy: { icon: _createColorIcon('#FFC446'), checkColor: '#FFF' },
  // green
  cxcg: { icon: _createColorIcon('#49B975'), checkColor: '#FFF' },
  // blue
  cxcu: { icon: _createColorIcon('#4182C3'), checkColor: '#FFF' },
}

export const CarColors = ({ parameters, label, onChange, currentQuery }) => {
  return (
    <div>
      <TextCallout1>{label}</TextCallout1>
      <ItemsWrapper>
        {parameters.map(({ queryKey }) => {
          const { icon, checkColor } = QUERY_KEY_TO_COLOR_DATA_MAP[queryKey]

          const handleClick = (e) => {
            onChange(e, queryKey, currentQuery[queryKey] ? '' : '1')
          }
          const selected = Boolean(currentQuery[queryKey])

          return (
            <ItemWrapper key={queryKey} onClick={handleClick}>
              {icon}
              {selected && (
                <IconCheck
                  width={12}
                  height={12}
                  color={checkColor}
                  style={{
                    position: 'absolute',
                    top: '4px',
                    left: '4px',
                  }}
                />
              )}
            </ItemWrapper>
          )
        })}
      </ItemsWrapper>
    </div>
  )
}

CarColors.propTypes = {
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      queryKey: PropTypes.string,
    }),
  ).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  currentQuery: PropTypes.object.isRequired,
}

export default CarColors
